import './figures.scss';
import React from 'react';
import FilesWithReferenceFiles from './FilesWithReferenceFiles';
var Figures = function Figures(_ref) {
  var apiRoot = _ref.apiRoot,
    methods = _ref.methods;
  return /*#__PURE__*/React.createElement(FilesWithReferenceFiles, {
    apiRoot: apiRoot,
    className: "order-figures",
    heading: "Your figure files",
    subheading: "figure-files-summary",
    methods: methods,
    types: {
      main: 'figures',
      reference: 'figuresRef'
    },
    names: {
      main: 'figureFiles',
      reference: 'figureReferenceFiles'
    }
  });
};
export default Figures;